export function CarParkLoadProgress({ loadedCount, totalCount }: { loadedCount: number; totalCount?: number }) {
  const target = totalCount && totalCount > loadedCount ? totalCount : undefined
  const progress = target ? Math.round((loadedCount / target) * 100) : 0

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 pt-3 pb-1">
      <div className="h-1 w-[100px] shrink-0 overflow-hidden rounded-full bg-old-stroke-secondary sm:w-[140px]">
        <div
          className="h-full rounded-full bg-old-primary transition-[width] duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-sm opacity-75">
        {target ? `Laster inn biler... ${loadedCount} av ${target}` : `Laster inn biler... ${loadedCount}`}
      </p>
    </div>
  )
}
